module.exports = __webpack_public_path__ + "img/instagram.85c9bafc.svg";